<ng-container id="thesEntry">
    <div class="row" *ngIf="!isHideIcon(); else noIconCollapseContainer">
        <div class="col-10 main-term-wrapper">
            <div id="entry-spinner-id-{{entry.termOrdinal}}{{pathIdentifier}}" class="spinner-container ng-hide">
                <ngx-spinner
                    name="entry-spinner"
                    bdColor="rgba(0,0,0,0)"
                    size="small"
                    [fullScreen]="false"
                    color="#000000"
                    type="ball-clip-rotate"
                >
                </ngx-spinner>
            </div>
            <label *ngIf="showCheckbox()">
            <input *ngIf="showCheckbox()"
                (click)="onEntryCheckboxChange(entry, $event)"
                type="checkbox"
                name="entry{{index}}"
                id="entry{{index}}"
                value="{{entry.name}}"
                title="entry{{index}}"
                [checked]="termsService.isChecked(entry.name, entry.paths) || termsService.isRelatedChecked(entry.name)">
            </label>
            <span *ngIf="linkable">
                <a tabindex="0" id="entry-{{entry.id}}" class="inline-block-height" role="button" (click)="onEntryClick(entry.termOrdinal)" (keydown.enter)="onEntryClick(entry.termOrdinal)">
                    <label id="mainTermEntryLabel-{{entry.id}}" for="entry{{index}}">{{entry.name}}</label>
                </a>
            </span>
            <span *ngIf="!linkable">
                <span class="entry-not-linkable strong">{{entry.name}}</span>
            </span>

            <div *ngIf="isDetailsAvailable()" id="entry-icon{{index}}">
                <svg xmlns="http://www.w3.org/2000/svg"
                    width="14" height="14" fill="currentColor"
                    class="bi bi-stickies-fill stickies-icon" viewBox="0 0 14 14"
                    role="button"
                    aria-expanded="false"
                    [attr.aria-controls]="'entry-notes' + notesId + index"
                    (click)="toggleCollapse('entry-notes' + notesId + index)"
                    (keydown.enter)="toggleCollapse('entry-notes' + notesId + index)"
                    tabindex="0"
                    >
                    <path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5"/>
                    <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177z"/>
                </svg>
            </div>
            <div *ngIf="hasQualifiers()" id="entry-qualifier-icon{{index}}">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" 
                    class="bi bi-funnel-fill funnel-icon" viewBox="0 0 14 14"
                    role="button"
                    aria-expanded="false"
                    [attr.aria-controls]="'entry-qualifier-notes' + collapsingNotesId + '-' + index"
                    (click)="toggleCollapse('entry-qualifier-notes' + collapsingNotesId + '-' + index)"
                    (keydown.enter)="toggleCollapse('entry-qualifier-notes' + collapsingNotesId + '-' + index)"
                    tabindex="0"
                    >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
                </svg>
            </div>
        </div>
        <div class="col-2 major-explode-wrapper">
            <label *ngIf="!isRoot && showCheckbox() && explode" aria-label="Explode">
            <input *ngIf="!isRoot && showCheckbox() && explode"
                (click)="onEntryExplodeCheckboxChange(entry, $event)"
                type="checkbox"
                name="entry{{index}}"
                id="entry-explode{{index}}"
                value="{{entry.name}}"
                class="explodeChk"
                [checked]="termsService.isExplodeChecked(entry.name, entry.paths)">
                </label>
            <label *ngIf="!isRoot && showCheckbox() && major" aria-label="Major">
            <input *ngIf="!isRoot && showCheckbox() && major"
                (click)="onEntryMajorCheckboxChange(entry, $event)"
                type="checkbox"
                name="entry{{index}}"
                id="entry-major{{index}}"
                value="{{entry.name}}"
                class="majorChk"
                [checked]="termsService.isMajorChecked(entry.name, entry.paths)">
                </label>
        </div>
    </div>
    <div class="row">
        <app-collapsing-notes [collapseId]="'entry-notes' + notesId + index" [entry]="entry" [thesaurusId]="thesaurusId" (collapseToggled)="toggleCollapse($event)"></app-collapsing-notes>
        <app-collapsing-qualifier-notes [collapseQualifierId]="'entry-qualifier-notes' + collapsingNotesId + '-' + index" [entry]="entry" [thesaurusId]="thesaurusId" (collapseToggled)="toggleCollapse($event)"></app-collapsing-qualifier-notes>
    </div>
</ng-container>

<ng-template #noIconCollapseContainer>
    <div class="row">
        <div class="col-12 main-term-wrapper">
            <input *ngIf="(showFrillsLexicon(entry) && isDetailsAvailable()) && !showBusinessThesaurus(entry)"
                (click)="onEntryCheckboxChange(entry, $event)"
                type="checkbox"
                name="entry{{index}}"
                id="entry{{index}}"
                value="{{entry.name}}"
                [checked]="termsService.isChecked(entry.name) || termsService.isRelatedChecked(entry.name)"
                [attr.aria-label]="entry.name">
            <a *ngIf="isDetailsAvailable() && !showBusinessThesaurus(entry)" tabindex="0" 
                id="entry-{{entry.id}}" 
                role="button" 
                aria-expanded="false"
                [attr.aria-controls]="'entry-notes' + notesId + index"
                (click)="toggleCollapse('entry-notes' + notesId + index); isDetailsAvailable()"
                (keydown.enter)="toggleCollapse('entry-notes' + notesId + index)">
                {{entry.name}}
            </a>
        </div>
        <div class="col-12 main-term-wrapper">
            <input *ngIf="showBusinessThesaurus(entry)"
                (click)="onEntryCheckboxChange(entry, $event)"
                type="checkbox"
                name="entry{{index}}"
                id="entry{{index}}"
                value="{{entry.name}}"
                [checked]="termsService.isChecked(entry.name) || termsService.isRelatedChecked(entry.name)"
                [attr.aria-label]="entry.name">
            <a *ngIf="showBusinessThesaurus(entry)" tabindex="0" 
                id="entry-{{entry.id}}" 
                role="button" 
                aria-expanded="false"
                [attr.aria-controls]="'entry-notes' + notesId + index"
                (click)="toggleCollapse('entry-notes' + notesId + index); isDetailsAvailable()"
                (keydown.enter)="toggleCollapse('entry-notes' + notesId + index)">
                {{entry.name}}
            </a>
        </div>
    </div>
    <div class="row">
        <div  class="row useFor small" *ngIf="isDetailsAvailable()">
            <!-- <span class="useForLabel">Use for: <strong>{{entry | json}}</strong></span> -->
            <div *ngFor="let term of entry.useTermFor; let i = index">
                <span *ngIf="i === 0" class="useForLabel">Use for: </span>
                <span *ngIf="i !== 0" class="useForLabel hidden-label">Use for: </span>
                <strong>{{term.name}}</strong>
            </div>
        </div>
    </div>
</ng-template>
